import { FC, useEffect } from "react";
import { Controller } from "react-hook-form";
import { observer } from "mobx-react-lite";
import { FilterCondition, PermissionAction } from "../../constants/Enums";

import { AutoComplete, ISelect, IRangePicker, FormField } from "../../ui-kit";
import { useHandleForm } from "../../hooks/useHandleForm";
import adminApi from "../Admin/api";

import { Filter } from "../../store/core";
import dictionaryStore from "../../store/dictionary";
import locale from "antd/es/date-picker/locale/ru_RU";

const DEFAULT_VALUES = {
  created: null,
  module: null,
  permissionAction: null,
  userName: "",
  organization: null,
};

interface ILoggingFilterProps {
  filter: Filter;
}

const LoggingPermissionFilter: FC<ILoggingFilterProps> = observer(
  ({ filter }) => {

    const { control, getValues, register, formState } =
      useHandleForm(null, DEFAULT_VALUES, null);

    const { data: dictionary } = dictionaryStore;
    const fields = [
      {
        component: ({ field }) => (
          <IRangePicker
            field={field}
            locale={locale}
            format="DD.MM.YYYY"
            label="Период"
          />
        ),
        name: "created",
      },
      {
        component: ({ field }) => (
          <ISelect
            field={field}
            optionsArr={dictionary['AppModule']}
            placeholder="Раздел"
          />
        ),
        name: "module",
      },
      {
        component: ({ field }) => (
          <ISelect
            field={field}
            optionsArr={Object.entries(PermissionAction)
              .filter(([key, value]) => typeof value === "string")
              .map(([key, value]) => ({ id: key, key, title: value }))}
            placeholder="Действие"
          />
        ),
        name: "permissionAction",
        placeholder: "Действие",
      },
      {
        component: () => (
          <FormField
            type="text"
            name="userName"
            register={register}
            label="Пользователь"
          />
        ),
        name: "userName",
        placeholder: "Пользователь",
      },
      {
        component: ({ field }) => (
          <AutoComplete
            field={field}
            label="Организация"
            getData={adminApi.getAllOrganizations}
          />
        ),

        name: "organization",
        placeholder: "Организация",
      },
    ];

    useEffect(() => {
      applyFilter();
    }, [formState]);

    const applyFilter = () => {
      const values = getValues();
      values.userName = {
        value: values.userName?.toLowerCase(),
        conditionType: FilterCondition.Like,
      };
      if (values.created) {
        if (values.created[0] && values.created[1]) {
          values.created = {
            value: values.created[0]?.format("YYYY-MM-DD"),
            valueTo: values.created[1]?.format("YYYY-MM-DD"),
            conditionType: FilterCondition.Between,
          };
        } else if (values.created[0] && !values.created[1]) {
          values.created = {
            value: values.created[0]?.format("YYYY-MM-DD"),
            conditionType: FilterCondition.Equal,
          };
        } else if (!values.created[0] && values.created[1]) {
          values.created = {
            value: values.created[1]?.format("YYYY-MM-DD"),
            conditionType: FilterCondition.Equal,
          };
        }
      }

      filter.setFilterItems(values);
    };

    return (
      <>
        {fields.map((filterField) => {
          return (
            <Controller
              key={dictionaryStore.isLoadingDict.value + filterField.name}
              control={control}
              name={filterField.name}
              render={filterField.component}
            />
          );
        })}
      </>
    );
  },
);

export default LoggingPermissionFilter;
